module.exports = __webpack_public_path__ + "d80aba5a4e6de9104eca23813ab9c796.png";


//////////////////
// WEBPACK FOOTER
// ./web/images/team/hallett.png
// module id = 648
// module chunks = 0